import React, { memo } from 'react';
import { View } from 'react-native';

import { LoadMain } from './LoadMain';
import type { LoadMainProps } from './types';

export type ButtonLoaderProps = Omit<LoadMainProps, 'variant'>;

/**
 * Compact inline loader for buttons, chips, and row accessories.
 * Uses the shared `ring` variant (Reanimated + SVG) — theme-aware light/dark + RTL-safe spin.
 */
export const ButtonLoader = memo(function ButtonLoader({
  size = 20,
  loopDurationMs = 950,
  accessibilityLabel,
  accessibilityRole,
  style,
  ...rest
}: ButtonLoaderProps) {
  const hide_a11y = accessibilityLabel == null || accessibilityLabel === '';

  return (
    <View
      accessibilityElementsHidden={hide_a11y}
      importantForAccessibility={hide_a11y ? 'no-hide-descendants' : 'auto'}
      style={style}>
      <LoadMain
        variant="ring"
        size={size}
        loopDurationMs={loopDurationMs}
        accessibilityLabel={accessibilityLabel ?? ''}
        accessibilityRole={hide_a11y ? undefined : accessibilityRole}
        {...rest}
      />
    </View>
  );
});

ButtonLoader.displayName = 'ButtonLoader';
